"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _crypto = _interopRequireDefault(require("./crypto"));
var _httpClient = _interopRequireDefault(require("@xto10x/core/lib/httpClient"));
var _constants = require("@xto10x/core/lib/constants");
var cloudApiUrl = process.env.REACT_APP_CLOUD_API_URL;
var persist = [_constants.StorageKey.PRODUCT_ID, _constants.StorageKey.USER_INFO, _constants.StorageKey.ORG_INFO, _constants.StorageKey.USER_ORGS, _constants.StorageKey.GOOGLE_ACCESS_TOKEN, _constants.StorageKey.COGNITO_ACCESS_TOKEN, _constants.StorageKey.REQUESTER_USER_ID, _constants.StorageKey.SIGN_IN_MODE, _constants.StorageKey.IS_GOOGLED_SIGNED, _constants.StorageKey.REDIRECT_URL, _constants.StorageKey.ANONYMOUS_USER_SESSION_ID];
var storage = {
  hasCookieAccess: function hasCookieAccess() {
    if (navigator.cookieEnabled) {
      document.cookie = 'ACCESS_CHECK=ENABLE';
      if (document.cookie.indexOf('ACCESS_CHECK=ENABLE') === -1) return false;
      document.cookie = 'ACCESS_CHECK=;';
      return true;
    }
    return false;
  },
  setCookie: function setCookie(cookieName, cookieValue) {
    var expireDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;
    if (!this.hasCookieAccess()) return;
    var d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";").concat(expires, ";path=/");
  },
  getCookie: function getCookie(cookieName) {
    if (!this.hasCookieAccess()) return null;
    var name = "".concat(cookieName, "=");
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  },
  hasLocalStorageAccess: function hasLocalStorageAccess() {
    try {
      if ('localStorage' in window && typeof localStorage !== 'undefined') {
        localStorage.setItem('ACCESS_CHECK', 'ENABLE');
        localStorage.getItem('ACCESS_CHECK');
        localStorage.removeItem('ACCESS_CHECK');
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  },
  // Method to save data in local storage. If encrypt is true data will be saved in encrypted form.
  saveDataInLocal: function saveDataInLocal(key, data) {
    var encrypt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var encryptKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.location.host;
    if (!this.hasLocalStorageAccess()) return;
    if (data == null) {
      localStorage.removeItem(key);
    } else if (encrypt) {
      localStorage.setItem(key, _crypto["default"].encrypt(data, encryptKey));
    } else {
      localStorage.setItem(key, data);
    }
  },
  // Method to get data from local storage. If encrypt is true data will be decrypted and returned back.
  getDataFromLocal: function getDataFromLocal(key) {
    var encrypt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var encryptKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location.host;
    if (!this.hasLocalStorageAccess()) return null;
    var data = localStorage.getItem(key);
    if (encrypt && data && data !== 'null') {
      try {
        return _crypto["default"].decrypt(data, encryptKey);
      } catch (e) {
        return null;
      }
    }
    return data;
  },
  // Method to remove data from local storage against given key.
  removeDataFromLocal: function removeDataFromLocal(key) {
    if (!this.hasLocalStorageAccess()) return;
    localStorage.removeItem(key);
  },
  // Method to clear all data from local storage.
  clearAllLocalData: function clearAllLocalData() {
    if (!this.hasLocalStorageAccess()) return;
    var dataMap = [];
    for (var _len = arguments.length, except = new Array(_len), _key = 0; _key < _len; _key++) {
      except[_key] = arguments[_key];
    }
    except.forEach(function (dataKey) {
      var value = localStorage.getItem(dataKey);
      if (value != null && value !== 'null') dataMap.push({
        key: dataKey,
        value: value
      });
    });
    localStorage.clear();
    dataMap.forEach(function (dataItem) {
      localStorage.setItem(dataItem.key, dataItem.value);
    });
  },
  hasSessionStorageAccess: function hasSessionStorageAccess() {
    try {
      if ('sessionStorage' in window && typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('ACCESS_CHECK', 'ENABLE');
        sessionStorage.getItem('ACCESS_CHECK');
        sessionStorage.removeItem('ACCESS_CHECK');
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  },
  // Method to save data in session storage. If encrypt is true data will be saved in encrypted form.
  saveDataInSession: function saveDataInSession(key, data) {
    var encrypt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!this.hasSessionStorageAccess()) return;
    if (data == null) {
      sessionStorage.removeItem(key);
    }
    if (encrypt) {
      sessionStorage.setItem(key, _crypto["default"].encrypt(data));
    } else {
      sessionStorage.setItem(key, data);
    }
  },
  // Method to get data from session storage. If encrypt is true data will be decrypted and returned back.
  getDataFromSession: function getDataFromSession(key) {
    var encrypt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!this.hasSessionStorageAccess()) return null;
    var data = sessionStorage.getItem(key);
    if (encrypt && data && data !== 'null') {
      try {
        return _crypto["default"].decrypt(data);
      } catch (e) {
        return null;
      }
    }
    return data;
  },
  // Method to remove data from session storage against given key.
  removeDataFromSession: function removeDataFromSession(key) {
    if (!this.hasSessionStorageAccess()) return;
    sessionStorage.removeItem(key);
  },
  // Method to clear all data from session storage.
  clearAllSessionData: function clearAllSessionData() {
    if (!this.hasSessionStorageAccess()) return;
    var dataMap = [];
    for (var _len2 = arguments.length, except = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      except[_key2] = arguments[_key2];
    }
    except.forEach(function (dataKey) {
      var value = sessionStorage.getItem(dataKey);
      if (value != null && value !== 'null') dataMap.push({
        key: dataKey,
        value: value
      });
    });
    sessionStorage.clear();
    dataMap.forEach(function (dataItem) {
      sessionStorage.setItem(dataItem.key, dataItem.value);
    });
  },
  saveFileInS3: function () {
    var _saveFileInS = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(name, file, type) {
      var params,
        bodyFormData,
        userResponse,
        _args = arguments;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            if (!(name && file)) {
              _context.next = 2;
              break;
            }
            bodyFormData = new FormData();
            bodyFormData.append('name', name);
            bodyFormData.append('file', file);
            bodyFormData.append('contentType', type || file.type);
            _context.next = 1;
            return _httpClient["default"].post("".concat(cloudApiUrl, "uploadImage"), bodyFormData, params, {
              'Content-Type': 'multipart/form-data'
            });
          case 1:
            userResponse = _context.sent;
            return _context.abrupt("return", userResponse.data);
          case 2:
            return _context.abrupt("return", null);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function saveFileInS3(_x, _x2, _x3) {
      return _saveFileInS.apply(this, arguments);
    }
    return saveFileInS3;
  }(),
  removeFileFromS3: function () {
    var _removeFileFromS = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(name) {
      var params,
        userResponse,
        _args2 = arguments;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            if (!name) {
              _context2.next = 2;
              break;
            }
            _context2.next = 1;
            return _httpClient["default"]["delete"]("".concat(cloudApiUrl, "deleteImage/").concat(name), {}, params);
          case 1:
            userResponse = _context2.sent;
            return _context2.abrupt("return", userResponse.data);
          case 2:
            return _context2.abrupt("return", null);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function removeFileFromS3(_x4) {
      return _removeFileFromS.apply(this, arguments);
    }
    return removeFileFromS3;
  }(),
  // Method to clearAllCookies.
  clearAllCookies: function clearAllCookies() {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i += 1) {
      var d = window.location.hostname.split('.');
      while (d.length > 0) {
        var cookieBase = "".concat(encodeURIComponent(cookies[i].split(';')[0].split('=')[0]), "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=").concat(d.join('.'), " ;path=");
        var p = window.location.pathname.split('/');
        document.cookie = "".concat(cookieBase, "/");
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }
  },
  clearAllStorage: function clearAllStorage() {
    var persistUserInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    storage.clearAllCookies(persistUserInfo);
    for (var _len3 = arguments.length, except = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      except[_key3 - 1] = arguments[_key3];
    }
    var persistKeys = persistUserInfo ? [].concat(persist, except) : [].concat(except);
    var redirectUrl = localStorage.getItem(_constants.StorageKey.REDIRECT_URL);
    storage.clearAllSessionData.apply(storage, (0, _toConsumableArray2["default"])(persistKeys));
    storage.clearAllLocalData.apply(storage, (0, _toConsumableArray2["default"])(persistKeys));
    if (redirectUrl != null && redirectUrl !== 'null') {
      localStorage.setItem(_constants.StorageKey.REDIRECT_URL, redirectUrl);
    }
    window.dispatchEvent(new Event('orgInfoUpdated'));
  },
  clearAllStorageWithoutCookies: function clearAllStorage() {
    var persistUserInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    for (var _len4 = arguments.length, except = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      except[_key4 - 1] = arguments[_key4];
    }
    var persistKeys = persistUserInfo ? [].concat(persist, except) : [].concat(except);
    var redirectUrl = localStorage.getItem(_constants.StorageKey.REDIRECT_URL);
    storage.clearAllSessionData.apply(storage, (0, _toConsumableArray2["default"])(persistKeys));
    storage.clearAllLocalData.apply(storage, (0, _toConsumableArray2["default"])(persistKeys));
    if (redirectUrl != null && redirectUrl !== 'null') localStorage.setItem(_constants.StorageKey.REDIRECT_URL, redirectUrl);
    window.dispatchEvent(new Event('orgInfoUpdated'));
  },
  clearOrgStorage: function clearOrgStorage() {
    storage.removeDataFromLocal(_constants.StorageKey.ORG_INFO);
    window.dispatchEvent(new Event('orgInfoUpdated'));
  }
};
var _default = exports["default"] = storage;